export const policiesNIE = [];

export const policiesNomadCitizen = [
  {
    link: '/nomad-citizen/nomad-citizen-policy-v2-2026-05.pdf',
    name: 'Global safety net insurance | Nomad Citizen 2.0 (07/2026)'
  },
  {
    link: '/nomad-citizen/nomad-citizen-policy-2025-07.pdf',
    name: 'Global safety net insurance | Nomad Citizen 1.0 (07/2025)'
  }
];

// Nomad Insurance Complete 3.0 is listed twice on purpose: the 03/2026 issue governs coverage
// that began before 01/10/2026 and the 10/2026 re-issue governs everything from that date, so
// both are in force at once for as long as the older cohort's coverage runs. Move the 03/2026
// entries down to archiveNIC only once no active coverage is governed by them.
/**
 * The 03/2026 issue, listed unconditionally. Coverage that began before 01/10/2026 stays
 * governed by it until that coverage ends, so it does not move to the archive on the
 * transition date — both issues are in force at the same time.
 */
const policiesNICSuperseded = [
  {
    link: '/nomad-insurance/complete/Nomad-Insurance-Complete-VIP-Standard-3.0.pdf',
    name: 'Nomad Insurance Complete VIP Standard 3.0 (31/03/2026)'
  },
  {
    link: '/nomad-insurance/complete/Nomad-Insurance-Complete-VIP-Premium-3.0.pdf',
    name: 'Nomad Insurance Complete VIP Premium 3.0 (31/03/2026)'
  },
  {
    link: '/nomad-insurance/complete/Nomad-Insurance-Complete-VIP-Premium-Plus-3.0.pdf',
    name: 'Nomad Insurance Complete VIP Premium Plus 3.0 (31/03/2026)'
  }
];

const NIC_CORRECTED_ON_SALE_FROM = '2026-09-09';

const policiesNICCorrected = [
  {
    link: '/policy-documents/nomad-insurance/complete/3.0/vip-standard-3.0.pdf',
    name: 'Nomad Insurance Complete VIP Standard 3.0 (01/10/2026)'
  },
  {
    link: '/policy-documents/nomad-insurance/complete/3.0/vip-premium-3.0.pdf',
    name: 'Nomad Insurance Complete VIP Premium 3.0 (01/10/2026)'
  },
  {
    link: '/policy-documents/nomad-insurance/complete/3.0/vip-premium-plus-3.0.pdf',
    name: 'Nomad Insurance Complete VIP Premium Plus 3.0 (01/10/2026)'
  }
];

export const policiesNIC = [
  ...(new Date().toISOString().slice(0, 10) >= NIC_CORRECTED_ON_SALE_FROM
    ? policiesNICCorrected
    : []),
  ...policiesNICSuperseded
];

/**
 * ! `/api/policy/[planId]` route lives in safetywing-member repo
 *
 * Same two-issue situation as Nomad Insurance Complete above. The /api/policy links resolve to
 * whatever is in force now, so their date has to be the date the current issue took effect —
 * 08/07/2026, when the corrected documents replaced the 03/2026 ones (safetywing-member commit
 * 4ab38168f). The superseded issue is listed against its own fixed URL so it keeps serving the
 * 03/2026 bytes.
 */
export const policiesNH = [
  {
    link: '/api/policy/167',
    name: 'Nomad Health VIP Standard 6.0 (08/07/2026)'
  },
  {
    link: '/api/policy/168',
    name: 'Nomad Health VIP Premium 6.0 (08/07/2026)'
  },
  {
    link: '/api/policy/169',
    name: 'Nomad Health VIP Premium Plus 6.0 (08/07/2026)'
  },
  {
    link: '/nomad-health/policies/Nomad-Health-VIP-Standard-6.0.pdf',
    name: 'Nomad Health VIP Standard 6.0 (31/03/2026)'
  },
  {
    link: '/nomad-health/policies/Nomad-Health-VIP-Premium-6.0.pdf',
    name: 'Nomad Health VIP Premium 6.0 (31/03/2026)'
  },
  {
    link: '/nomad-health/policies/Nomad-Health-VIP-Premium-Plus-6.0.pdf',
    name: 'Nomad Health VIP Premium Plus 6.0 (31/03/2026)'
  }
];

/**
 * ! `/api/policy/[planId]` route lives in safetywing-member repo
 */
export const policiesCommunityRH = [
  {
    link: '/api/policy/123',
    name: 'Remote Health Community 5.0 Premium+',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/122',
    name: 'Remote Health Community 5.0 Premium',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/121',
    name: 'Remote Health Community 5.0 Standard',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/120',
    name: 'Remote Health Community 5.0 Essential',
    effectiveDate: '2026-03-18'
  }
];

/**
 * ! `/api/policy/[planId]` route lives in safetywing-member repo
 */
export const policiesCommunityStarterRH = [
  {
    link: '/api/policy/156',
    name: 'Remote Health Starter 5.0 Premium+',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/155',
    name: 'Remote Health Starter 5.0 Premium',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/154',
    name: 'Remote Health Starter 5.0 Standard',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/153',
    name: 'Remote Health Starter 5.0 Essential',
    effectiveDate: '2026-03-18'
  }
];

/**
 * ! `/api/policy/[planId]` route lives in safetywing-member repo
 */
export const policiesCommunityPersonalRH = [
  {
    link: '/api/policy/163',
    name: 'Remote Health Personal 5.0 Premium+',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/162',
    name: 'Remote Health Personal 5.0 Premium',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/161',
    name: 'Remote Health Personal 5.0 Standard',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/160',
    name: 'Remote Health Personal 5.0 Essential',
    effectiveDate: '2026-03-18'
  }
];

/**
 * ! `/api/policy/[planId]` route lives in safetywing-member repo
 */
export const policiesCommunityLifeRH = [
  {
    link: '/api/policy/149',
    name: 'Remote Health Community 5.0 Premium+ (Life)',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/148',
    name: 'Remote Health Community 5.0 Premium (Life)',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/147',
    name: 'Remote Health Community 5.0 Standard (Life)',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/146',
    name: 'Remote Health Community 5.0 Essential (Life)',
    effectiveDate: '2026-03-18'
  }
];

/**
 * ! `/api/policy/[planId]` route lives in safetywing-member repo
 */
export const policiesIndividualsRH = [
  {
    link: '/api/policy/130',
    name: 'Remote Health Individual 5.0 Premium+',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/129',
    name: 'Remote Health Individual 5.0 Premium',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/128',
    name: 'Remote Health Individual 5.0 Standard',
    effectiveDate: '2026-03-18'
  },
  {
    link: '/api/policy/127',
    name: 'Remote Health Individual 5.0 Essential',
    effectiveDate: '2026-03-18'
  }
];

export const policiesRHUSA = [
  {
    link: '/policy-documents/usa-synopsis.pdf',
    name: 'USA Summary of Coverage (01/2026)',
    effectiveDate: '2026-01-01'
  }
];

export const archiveNI = [
  {
    link: '/nomad-insurance/description-of-coverage.pdf',
    name: 'Old policy WorldTrips (02/2023)',
    effectiveDate: '2023-02-01'
  },
  {
    link: '/nomad-insurance/description-of-coverage-2022-4.pdf',
    name: 'Old policy WorldTrips (04/2022)',
    effectiveDate: '2022-04-01'
  },
  {
    link: '/nomad-insurance/description-of-coverage-2020-8.pdf',
    name: 'Old policy Tokio Marine (08/2020)',
    effectiveDate: '2020-08-01'
  },
  {
    link: '/nomad-insurance/description-of-coverage-2020-4.pdf',
    name: 'Old policy Tokio Marine (04/2020)',
    effectiveDate: '2020-04-01'
  },
  {
    link: '/nomad-insurance/description-of-coverage-2019-2.pdf',
    name: 'Old policy Tokio Marine (09/2019)',
    effectiveDate: '2019-09-01'
  },
  {
    link: '/nomad-insurance/safety-wing-specimen-policy.pdf',
    name: 'Old policy Tokio Marine (01/2019)',
    effectiveDate: '2019-01-01'
  },
  {
    link: '/nomad-insurance/safety-wing-specimen-policy-2018.pdf',
    name: 'Original policy Tokio Marine (01/2018)',
    effectiveDate: '2018-01-01'
  }
];

export const archiveNIC = [
  {
    link: '/nomad-insurance/complete/NI-Complete-Policy-2025-07-09-dental+electronics.pdf',
    name: 'Nomad Insurance Complete VUMI+Carrier (07/2025)'
  },
  {
    link: '/nomad-insurance/complete/standard_nomad_insurance_complete_vumi+carrier_2025-04.pdf',
    name: 'Standard Nomad Insurance Complete VUMI+Carrier (04/2025)'
  },
  {
    link: '/nomad-insurance/complete/premium_nomad_insurance_complete_vumi+carrier_2025-04.pdf',
    name: 'Premium Nomad Insurance Complete VUMI+Carrier (04/2025)'
  },
  {
    link: '/nomad-insurance/complete/premium_plus_nomad_insurance_complete_vumi+carrier_2025-04.pdf',
    name: 'Premium Plus Nomad Insurance Complete VUMI+Carrier (04/2025)'
  },
  {
    link: '/nomad-insurance/complete/standard_nomad_insurance_complete_vumi+carrier_2024-12.pdf',
    name: 'Standard Nomad Insurance Complete VUMI+Carrier (12/2024)'
  }
];

export const archiveNH = [
  {
    link: '/nomad-health/policies/nomad-health-premium-plus-plan-5.0.pdf',
    name: 'Premium Plus Nomad Health VUMI (04/2025)'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium-plan-5.0.pdf',
    name: 'Premium Nomad Health VUMI (04/2025)'
  },
  {
    link: '/nomad-health/policies/nomad-health-standard-plan-5.0.pdf',
    name: 'Standard Nomad Health VUMI (04/2025)'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium-plus-maternity-plan-4.0.pdf',
    name: 'Premium Plus Nomad Health VUMI (08/2024)'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium-plan-4.0.pdf',
    name: 'Premium Nomad Health VUMI (08/2024)'
  },
  {
    link: '/nomad-health/policies/nomad-health-standard-plan-4.0.pdf',
    name: 'Standard Nomad Health VUMI (08/2024)'
  },
  {
    link: '/remote-health/policy-documents/v3/nomad-health-premium-plus-plan-3.0.pdf',
    name: 'Premium Plus Nomad Health VUMI (12/2023)'
  },
  {
    link: '/remote-health/policy-documents/v3/nomad-health-premium-plan-3.0.pdf',
    name: 'Premium Nomad Health VUMI (12/2023)'
  },
  {
    link: '/remote-health/policy-documents/v3/nomad-health-standard-plan-3.0.pdf',
    name: 'Standard Nomad Health VUMI (12/2023)'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium+maternity-plan.pdf',
    name: 'Premium Plus Nomad Health VUMI (07/2023)',
    effectiveDate: '2023-07-01'
  },
  {
    link: '/nomad-health/policies/nomad-health-premium-plan.pdf',
    name: 'Premium Nomad Health VUMI (07/2023)',
    effectiveDate: '2023-07-01'
  },
  {
    link: '/nomad-health/policies/nomad-health-standard-plan.pdf',
    name: 'Standard Nomad Health VUMI (07/2023)',
    effectiveDate: '2023-07-01'
  },
  {
    link: '/remote-health/premium-plus-nomad-2.0.pdf',
    name: 'Vumi Premium Plus Nomad Plan (07/2023)'
  },
  {
    link: '/remote-health/premium-individual-plan-2.0.pdf',
    name: 'Vumi Premium Individual Plan (12/2022)'
  },
  {
    link: '/remote-health/standard-individual-plan-2.0.pdf',
    name: 'Vumi Standard Individual Plan (12/2022)'
  },
  {
    link: '/nomad-health/MemberHandbook.pdf',
    name: 'Original policy (01/2020)'
  }
];

export const archiveCommunityRH = [
  {
    link: '/remote-health/policy-documents/v4/premium-plus-community-plan-4-0V2025-04-15.pdf',
    name: 'Premium Plus Community VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/premium-community-plan-4-0V2025-04-15.pdf',
    name: 'Premium Community VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/standard-community-plan-4-0V2025-04-15.pdf',
    name: 'Standard Community VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/essential-community-plan-4-0V2025-04-15.pdf',
    name: 'Essential Community VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },

  {
    link: '/remote-health/policy-documents/life/premium-plus-community-life-plan-2025-05-01.pdf',
    name: 'Premium Plus Community + Life VUMI (05/2025)',
    effectiveDate: '2025-05-01'
  },
  {
    link: '/remote-health/policy-documents/life/premium-community-life-plan-2025-05-01.pdf',
    name: 'Premium Community + Life VUMI (05/2025)',
    effectiveDate: '2025-05-01'
  },
  {
    link: '/remote-health/policy-documents/life/standard-community-life-plan-2025-05-01.pdf',
    name: 'Standard Community + Life VUMI (05/2025)',
    effectiveDate: '2025-05-01'
  },
  {
    link: '/remote-health/policy-documents/life/essential-community-life-plan-2025-05-01.pdf',
    name: 'Essential Community + Life VUMI (05/2025)',
    effectiveDate: '2025-05-01'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-plus-community-plan-3-0V2023-12-15.pdf',
    name: 'Premium Plus Community VUMI (12/2023)',
    effectiveDate: '2023-12-15'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-community-plan-3-0V2023-12-15.pdf',
    name: 'Premium Community VUMI (12/2023)',
    effectiveDate: '2023-12-15'
  },
  {
    link: '/remote-health/policy-documents/v3/standard-community-plan-3-0V2023-12-15.pdf',
    name: 'Standard Community VUMI (12/2023)',
    effectiveDate: '2023-12-15'
  },
  {
    link: '/remote-health/policy-documents/v3/essential-community-plan-3-0V2023-12-15.pdf',
    name: 'Essential Community VUMI (12/2023)'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-plus-community-plan-2024-04.pdf',
    name: 'Premium Plus Community VUMI (04/2024)',
    effectiveDate: '2024-04-15'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-community-plan-2024-04.pdf',
    name: 'Premium Community VUMI (04/2024)',
    effectiveDate: '2024-04-15'
  },
  {
    link: '/remote-health/policy-documents/v3/standard-community-plan-2024-04.pdf',
    name: 'Standard Community VUMI (04/2024)',
    effectiveDate: '2024-04-15'
  },
  {
    link: '/remote-health/policy-documents/v3/essential-community-plan-2024-04.pdf',
    name: 'Essential Community VUMI (04/2024)',
    effectiveDate: '2024-04-15'
  },
  {
    link: '/remote-health/premium-plus-community-2.0-PR.pdf',
    name: 'Premium Plus Community VUMI PR (07/2023)'
  },
  {
    link: '/remote-health/premium-plus-community-2.0-T&C.pdf',
    name: 'Premium Plus Community VUMI T&C (07/2023)'
  },
  {
    link: '/remote-health/premium+maternity-community-plan-2.0-PR.pdf',
    name: 'Premium Plus Community VUMI PR (04/2023)'
  },
  {
    link: '/remote-health/premium-community-plan-2.0-PR.pdf',
    name: 'Premium Community VUMI PR (04/2023)'
  },
  {
    link: '/remote-health/standard-community-plan-2.0-PR.pdf',
    name: 'Standard Community VUMI PR (04/2023)'
  },
  {
    link: '/remote-health/premium+maternity-community-plan-2.0-T&C.pdf',
    name: 'Premium Plus Community VUMI T&C (04/2023)'
  },
  {
    link: '/remote-health/premium-community-plan-2.0-T&C.pdf',
    name: 'Premium Community VUMI T&C (04/2023)'
  },
  {
    link: '/remote-health/standard-community-plan-2.0-T&C.pdf',
    name: 'Standard Community VUMI T&C (04/2023)'
  },
  {
    link: '/remote-health/premium+maternity-community-plan-2.0.pdf',
    name: 'Premium Plus Community VUMI (05/2022)'
  },
  {
    link: '/remote-health/premium-community-plan-2.0.pdf',
    name: 'Premium Community VUMI (05/2022)'
  },
  {
    link: '/remote-health/standard-community-plan-2.0.pdf',
    name: 'Standard Community VUMI (05/2022)'
  },
  {
    link: '/remote-health/premium-community-plan-1.5.pdf',
    name: 'Vumi Premium Community Plan 1.5'
  },
  {
    link: '/remote-health/standard-community-plan-1.5.pdf',
    name: 'Vumi Standard Community Plan 1.5'
  },
  {
    link: '/remote-health/MemberHandbook-Vumi-V2.pdf',
    name: 'Vumi 1.5 (08/2021)'
  },
  {
    link: '/remote-health/MemberHandbook-Vumi-V1.pdf',
    name: 'VUMI 1.0 (04/2021)'
  },
  {
    link: '/remote-health/MemberHandbook-04-2021.pdf',
    name: 'Updated policy NOW Health (04/2021)'
  },
  {
    link: '/remote-health/MemberHandbook.pdf',
    name: 'Original policy NOW Health (01/2020)'
  }
];

export const archiveAffinityRH = [
  {
    link: '/remote-health/policy-documents/v3/premium_plus-affinity-3-0-plan-2024-04.pdf',
    name: 'Premium Plus Affinity VUMI (04/2024)'
  },
  {
    link: '/remote-health/policy-documents/v3/premium-affinity-3-0-plan-2024-04.pdf',
    name: 'Premium Affinity VUMI (04/2024)'
  },
  {
    link: '/remote-health/policy-documents/v3/standard-affinity-3-0-plan-2024-04.pdf',
    name: 'Standard Affinity VUMI (04/2024)'
  },
  {
    link: '/remote-health/policy-documents/v3/essential-affinity-3-0-plan-2024-04.pdf',
    name: 'Essential Affinity VUMI (04/2024)'
  },
  {
    link: '/remote-health/premium-plus-affinity-2.0.pdf',
    name: 'Premium Plus Affinity VUMI (07/2023)'
  },
  {
    link: '/remote-health/premium+maternity-affinity-plan-2.0.pdf',
    name: 'Premium Affinity VUMI (09/2022)'
  },
  {
    link: '/remote-health/premium-affinity-plan-2.0.pdf',
    name: 'Standard Affinity VUMI (09/2022)'
  },
  {
    link: '/remote-health/standard-affinity-plan-2.0.pdf',
    name: 'Essential Affinity VUMI (09/2022)'
  },
  {
    link: '/nomad-health/Deel-Policy-document.pdf',
    name: 'Vumi DEEL Affinity Plan'
  }
];

export const archiveIndividualsRH = [
  {
    link: '/remote-health/policy-documents/v4/premium-plus-individuals-4-0-plan-2025-04.pdf',
    name: 'Premium Plus Individual VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/premium-individuals-4-0-plan-2025-04.pdf',
    name: 'Premium Individual VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/standard-individuals-4-0-plan-2025-04.pdf',
    name: 'Standard Individual VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  },
  {
    link: '/remote-health/policy-documents/v4/essential-individuals-4-0-plan-2025-04.pdf',
    name: 'Essential Individual VUMI (04/2025)',
    effectiveDate: '2025-04-15'
  }
];
